<!--
This is a copy of "Simple with chevrons" Breadcrumbs from tailwindui.
Modifications:
 - Added icons
 - Use vue-router for navigation
 - Highlight the current route in primary color
 -->
<template>
    <nav class="flex" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center">
            <li v-for="(item, i) in items" :key="item.title">
                <div class="flex items-center">
                    <ChevronRightIcon v-if="i" class="shrink-0 h-5 w-5 text-gray-400 mx-4" aria-hidden="true" />
                    <RouterLink v-if="item.to" v-slot="{ href, isExactActive }" :to="item.to" custom>
                        <div
                            class="flex flex-row text-sm font-normal text-gray-500 items-center"
                            :class="{
                                'text-primary': isExactActive,
                            }"
                        >
                            <Icon v-if="item.icon" class="mr-2" :icon="item.icon" :size="20" />
                            <a
                                :href="href"
                                class="hover:text-gray-700"
                                :aria-current="isExactActive ? 'page' : undefined"
                                >{{ item.title }}</a
                            >
                        </div>
                    </RouterLink>
                    <div v-else class="flex flex-row text-sm font-normal text-gray-500 items-center">
                        <icon v-if="item.icon" class="mr-2" :icon="item.icon" :size="20" />
                        {{ item.title }}
                    </div>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';
import Icon from './Icon.vue';
import ChevronRightIcon from './Icon/ChevronRightIcon.vue';

export type Breadcrumb = {
    icon?: string;
    title: string;
    to: RouteLocationRaw;
};

defineProps<{
    items: Breadcrumb[];
}>();
</script>
